import { Component, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { DatePipe, Location } from '@angular/common';

@Component({
  selector: 'app-question-form',
  templateUrl: './question-form.component.html',
  styleUrls: ['./question-form.component.scss']
})

export class QuestionFormComponent implements OnInit {

  public city=history.state.city; // value passed from parent component via state method

  public metalearning: any = {};
  public learning: any;
  public other: any;
  public summary: any;
  public durationFrom: any;
  public durationTo: any;

  public Editor: ClassicEditor;
  public valid: boolean = false;

  public QuillConfiguration = {
    toolbar: {
      container:
        [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
        ],
    },
  }
  
  public metas: any = [];
  public questions: any = [];

  constructor(private req: HttpRequestsService<any>, private _location: Location, public datepipe: DatePipe) { }

  ngOnInit(): void {
    this.req.getAllMetas().subscribe((res) => this.metas = res);
  }
  
  onSelect(meta){
    this.req.getAllQuestions(meta.Meta).subscribe((res) => this.questions = res);
  }

  onSubmit() {
    let message: any = '';

    if((this.metas == '') || (this.metas == undefined)) {
      if (message == '') {
        message = 'A meta level Learning Question needs to be selected from the list'
      }
      else {
        message = message + ', a meta level Learning Question needs to be selected from the list'
      }
    }
    if((this.learning == undefined && this.other == undefined) || (this.learning == '' && this.other == undefined) || (this.learning == '' && this.other == '') || (this.learning == undefined && this.other == '')) {
      if (message == '') {
        message = 'A Learning Question needs to be selected from the list or passed as "Other"'
      }
      else {
        message = message + ', a Learning Question needs to be selected from the list or passed as "Other"'
      }
    }
    if (this.durationFrom == undefined) {
      if (message == '') {
        message = 'Starting date is required'
      }
      else {
        message = message + ', starting date is required'
      }
    }
    if(this.durationFrom == null) {
      Swal.fire(
        message,
        'Please correct your form and submit it again!',
        'error'
      )
      message = '';
    }

    let data = {
      city: this.city ? this.city : '',
      metaLQ: this.metalearning ? this.metalearning.Meta : '',
      learning: this.learning ? this.learning : '',
      summary: this.summary ? this.summary : '',
      other: this.other ? this.other : '',
      durationFrom: this.datepipe.transform(this.durationFrom, 'yyyy-MM-dd'),
      durationTo: this.durationTo ? this.datepipe.transform(this.durationTo, 'yyyy-MM-dd') : null
    }

    let dataObj = JSON.stringify(data);

    if (message == '' && this.durationFrom != null){
      let type = 'lq';
      this.req.postContent(dataObj, type).subscribe(
        res => {
          Swal.fire(
            'Done!',
            'Your form was submitted successfully!',
            'success'
          )
          this.submitForm();
        },
        error => {
          console.log(error)
        }
      )
    }
  }

  submitForm() {
    window.scroll(0,0);
    this.durationFrom = null;
    this.durationTo = null;
    this.summary = '';
    this.metalearning = '';
    this.learning = '';
    this.other = '';
    this._location.back();
  }
}